<template>
  <div class="user-account-layout desktop" v-if="isLoggedIn">
    <app-header-desktop />

    <div class="menu-column">
      <nuxt-link :to="$puLocalePath({ name: 'account' })">
        <user-account-users-info />
      </nuxt-link>
      <account-sections-menu />
      <user-account-footer />
    </div>

    <slot />
  </div>
</template>

<script lang="ts">
import AuthMixin from '~/mixins/AuthMixin'
import ErrorCapture from '~/mixins/ErrorCaptured'
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  mixins: [ErrorCapture, AuthMixin],
  setup() {
    const searchWizardStore = useSearchWizardStore()
    const authStore = useAuthStore()
    return {
      authStore,
      searchWizardStore,
    }
  },
})
class UserAccountDesktop extends Vue {}

export default toNative(UserAccountDesktop)
</script>
<style>
@import url('~/assets/css/user-account.css');
</style>
<style scoped>
/* desktop only */
.user-account-layout.desktop {
  display: grid;
  grid-template-columns: minmax(auto, 16em) auto;
  grid-template-rows: auto 1fr;
  min-height: 100dvh;
  background-color: white;
}

.user-account-layout.desktop :deep(.page-title) {
  color: var(--colour-dark-blue);
}

.user-account-layout.desktop :deep(header) {
  grid-column: 1/3;
  grid-row: 1/2;
  background: white;
  max-width: none;
}

.user-account-layout.desktop :deep(.nav-bar) {
  background-color: transparent;
  height: auto;
}

.menu-column {
  background-color: var(--colour-mid-green);
  border-radius: 0 0.75em 0 0;
}

.user-account-layout.desktop :deep(.users-info) {
  align-items: start;
  flex-direction: row-reverse;
  font-size: var(--large);
  gap: 0.5em;
  margin: 0;
  padding: 1.4em;
}

.user-account-layout.desktop :deep(.users-info h1) {
  font-weight: 600;
  text-align: left;
}

.user-account-layout.desktop :deep(li.user-account-link > a) {
  color: var(--colour-dark-blue);
  border-color: var(--colour-orange);
}

.menu-column {
  display: flex;
  flex-direction: column;
}

.menu-column a {
  text-decoration: none;
}

.menu-column :deep(.user-menu.desktop) {
  margin: 0;
  padding: 1.4em;
  display: flex;
  flex-direction: column;
}

.menu-column :deep(.user-menu.desktop .menu-item-text) {
  font-size: var(--large);
  padding: 0;
  margin: auto 0;
  text-align: left;
}

.menu-column :deep(.user-menu.desktop a[disabled]:before) {
  top: 0.2em;
  left: 1em;
  color: white;
  padding: 0;
  text-align: left;
  position: absolute;
}

.menu-column :deep(.user-menu.desktop a) {
  min-width: 100%;
  min-height: 3em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5em 0 1em;
  background-image: none;
}

.menu-column :deep(.manager-portal.desktop:hover),
.menu-column :deep(.manager-portal.desktop:focus-visible),
.menu-column :deep(.user-menu.desktop a:hover),
.menu-column :deep(.user-menu.desktop a:focus-visible) {
  box-shadow: 0 0 0 4px white;
  filter: none;
}

.menu-column :deep(.user-menu.desktop a.router-link-exact-active) {
  box-shadow: 0 0 0 4px var(--colour-orange);
}

.menu-column :deep(.user-menu.desktop a:after) {
  position: relative;
  top: auto;
  right: auto;
  height: 1.55em;
  width: 2em;
}

.menu-column :deep(.notification-badge) {
  left: -0.5em;
  top: -0.5em;
  font-size: var(--title);
  background-color: var(--colour-orange);
  color: var(--colour-dark-green);
  box-shadow: var(--card-box-shadow);
}

.menu-column :deep(.manager-portal.desktop) {
  margin: 1.4em;
  font-size: inherit;
}

.menu-column :deep(.footer) {
  flex-direction: column;
  align-items: start;
}

.menu-column :deep(.footer a) {
  color: white;
  border-color: #73a57d;
}

.user-menu.desktop a.router-link-exact-active {
  border: 4px solid var(--colour-orange);
}

.user-account-layout.desktop :deep(.bookings),
.user-account-layout.desktop :deep(.booking-detail),
.user-account-layout.desktop :deep(.account-details),
.user-account-layout.desktop :deep(.settings),
.user-account-layout.desktop :deep(.allocation-alerts-page),
.user-account-layout.desktop :deep(.favourites),
.user-account-layout.desktop :deep(.reviews) {
  padding: 0 3vw 3em;
}

.user-account-layout.desktop :deep(.booking-detail),
.user-account-layout.desktop :deep(.booking-section),
.user-account-layout.desktop :deep(.account-details),
.user-account-layout.desktop :deep(.settings),
.user-account-layout.desktop :deep(.review) {
  max-width: var(--user-account-desktop-width);
  justify-self: left;
}

.user-account-layout.desktop :deep(.account-details),
.user-account-layout.desktop :deep(.settings) {
  width: 100%;
  min-height: 100%;
}

.user-account-layout.desktop :deep(.booking-detail .actions) {
  flex-direction: row;
  gap: 2em;
}

.user-account-menu :deep(.add-a-review) {
  margin: 0.5em -1.2em -0.7em;
  padding: 0.5em 1em 0.7em;
  font-size: var(--body);
}

.user-account-layout.desktop :deep(.pending-reviews .add-a-review) {
  margin: 1em 0;
}

.user-account-layout.desktop :deep(.popover-content) {
  margin: auto;
  max-width: 38em;
}
</style>
